import Vue from 'vue'
import ClipboardJS from 'clipboard'

export default {
  inserted(el, binding) {
    el.clipboard = new ClipboardJS(el, {
      text() {
        return binding.value
      }
    })
    el.clipboard.on('success', (e) => {
      Vue.prototype.$message({
        message: '复制成功',
        type: 'success'
      })
      e.clearSelection()
    })
    el.clipboard.on('error', () => {
      console.error('复制失败')
    })
  },
  unbind(el) {
    el.clipboard.destroy()
    delete el.clipboard
  }
}
